import { PageContainer } from "./layout/style";
import LandingSlide from "./slides/LandingSlide";
import CreativeTeamSlide from "./slides/CreativeTeamSlide";
import ProxiesVis from "./vis/ProxiesVis";
import { SlideContainer } from "./layout/style";
import { useState } from "react";
import VideoSlide from "./slides/videoSlide";
import LoopSlide from "./slides/LoopSlide";
import LearnMoreSlide from "./slides/LearnMoreSlide";
import BottomNavigationBar from "./layout/BottomNavigationBar";
import StickyHeader from "./layout/StickyHeader";
import VisualizationDiscussionSlide from "./slides/VisualizationDiscussionSlide";

export const WhichSlide = {
  Landing: "Landing",
  VideoSample: "VideoSample",
  LoopStructure: "LoopStructure",
  VisExplanation: "VisualizationExplanation",
  VisDemo: "VisDemo",
  CreativeTeam: "CreativeTeam",
  LearnMore: "LearnMore"
}

const ProxiesDemo = () => {

  let [whichSlide, setWhichSlide] = useState(WhichSlide.Landing);

  let contentElement = null;
  if (whichSlide === WhichSlide.Landing) {
    contentElement = <LandingSlide />;

  } else if (whichSlide === WhichSlide.VideoSample) {
    contentElement = <VideoSlide />
  } else if (whichSlide === WhichSlide.LoopStructure) {
    contentElement = <LoopSlide />
  } else if (whichSlide === WhichSlide.VisExplanation) {
    contentElement = <VisualizationDiscussionSlide />
  } else if (whichSlide === WhichSlide.VisDemo) {
    contentElement = <ProxiesVis which={whichSlide} />
  } else if (whichSlide === WhichSlide.CreativeTeam) {
    contentElement = <CreativeTeamSlide />
  } else {
    contentElement = <LandingSlide />

  }

  let stickyHeaderElement = whichSlide !== WhichSlide.Landing && whichSlide !== WhichSlide.VisDemo ? <StickyHeader /> : null;

  return <PageContainer>
    {stickyHeaderElement}
    <SlideContainer>

      {contentElement}
    </SlideContainer>
    <BottomNavigationBar currentSlide={whichSlide} changeSlide={setWhichSlide} />
  </PageContainer>;
}

export default ProxiesDemo;
